import ProgramProgress from '../../components/programs/FullProgress'
import { createApp } from 'vue';

if (document.getElementById('full-progress-container')) {
    const app = createApp({
        components: {
            ProgramProgress
        }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#full-progress-container');
}
